import { Col, Row } from 'reactstrap';

interface IProps {
    vehicleImagePath: string,
    vehicleMakeModel: string,
    vehicleTypeImagePath: string,
    showLoadingSymbol: boolean;
}

export const VehicleImage = ({ vehicleImagePath, vehicleMakeModel, vehicleTypeImagePath, showLoadingSymbol }: IProps) => {

    const imageFilePath = import.meta.env.REACT_APP_IMAGE_LOCATION ? import.meta.env.REACT_APP_IMAGE_LOCATION + "/" : '';

    return (

        <Row>
            <Col>
                {vehicleImagePath ? (
                    <div className="vehicleImage">
                        <img src={`${imageFilePath}${vehicleImagePath}`} alt={`A ${vehicleMakeModel}.`} />
                    </div>
                ) : (
                    <>
                        {vehicleTypeImagePath ? (
                                <div className="vehicleTypeImage">
                                    <img src={`${imageFilePath}${vehicleTypeImagePath}`} alt={`A ${vehicleMakeModel}.`} />
                                        <p className="bottomLeftImageText">Image only depicts<br />vehicle type. Photo of<br />actual model coming soon.</p>
                                </div>
                            ) : (
                                <>
                                    {showLoadingSymbol ? (
                                            <div className="noImageAvailable">
                                                <div className="loadingImage">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="76" height="75" viewBox="0 0 76 75" fill="none">
                                                        <path d="M68.4688 30.4688C64.5854 30.4688 61.4375 33.6167 61.4375 37.5C61.4375 41.3833 64.5854 44.5312 68.4688 44.5312C72.3521 44.5312 75.5 41.3833 75.5 37.5C75.5 33.6167 72.3521 30.4688 68.4688 30.4688ZM14.5625 37.5C14.5625 41.3833 11.4146 44.5312 7.53125 44.5312C3.64795 44.5312 0.5 41.3833 0.5 37.5C0.5 33.6167 3.64795 30.4687 7.53125 30.4687C11.4146 30.4687 14.5625 33.6167 14.5625 37.5ZM45.0313 7.03125C45.0313 10.9146 41.8833 14.0625 38 14.0625C34.1167 14.0625 30.9688 10.9146 30.9688 7.03125C30.9688 3.14795 34.1167 0 38 0C41.8833 0 45.0313 3.14795 45.0313 7.03125ZM38 60.9375C41.8833 60.9375 45.0312 64.0854 45.0312 67.9688C45.0312 71.8521 41.8833 75 38 75C34.1167 75 30.9688 71.8521 30.9688 67.9687C30.9688 64.0854 34.1167 60.9375 38 60.9375ZM23.4866 59.0446C23.4866 62.9279 20.3387 66.0759 16.4554 66.0759C12.5721 66.0759 9.42412 62.9279 9.42412 59.0446C9.42412 55.1613 12.5721 52.0134 16.4554 52.0134C20.3385 52.0134 23.4866 55.1615 23.4866 59.0446ZM23.4866 15.9554C23.4866 19.8387 20.3387 22.9866 16.4554 22.9866C12.5721 22.9866 9.42412 19.8387 9.42412 15.9554C9.42412 12.0721 12.5721 8.92412 16.4554 8.92412C20.3385 8.92412 23.4866 12.0721 23.4866 15.9554ZM66.5759 59.0446C66.5759 62.9279 63.4279 66.0759 59.5446 66.0759C55.6613 66.0759 52.5134 62.9279 52.5134 59.0446C52.5134 55.1613 55.6613 52.0134 59.5446 52.0134C63.4279 52.0134 66.5759 55.1615 66.5759 59.0446Z" fill="#CCCCCC" />
                                                    </svg>
                                                </div>
                                            </div>
                                    ) : (
                                        <div className="noImageAvailable">
                                            <div className="backgroundImg"></div>
                                        </div>
                                    )}
                            </>
                        )}
                    </>
                )}
            </Col>
        </Row>
    )
}